<div class="mp-container" (click)="$event.stopPropagation()">

  <!-- Header -->
  <div class="mp-header" *ngIf="icon || title">
    <span class="material-symbols-outlined mp-header-icon" *ngIf="icon">{{ icon }}</span>
    <span class="mp-header-title" *ngIf="title">{{ title }}</span>
    <ng-content select="[popup-header]"></ng-content>
  </div>

  <!-- Body -->
  <div class="mp-body">
    <ng-content select="[popup-body]"></ng-content>
    <ng-content></ng-content>
  </div>

  <!-- Footer -->
  <div class="mp-footer" *ngIf="!hideFooter">
    <ng-content select="[popup-footer]"></ng-content>
    <ng-container *ngIf="true">
      <kt-button-v1
        variant="stroked"
        theme="muted"
        [label]="cancelLabel"
        (btnClick)="onCancel()">
      </kt-button-v1>
      <kt-button-v1
        variant="flat"
        [theme]="confirmTheme === 'danger' ? 'danger' : confirmTheme === 'success' ? 'success' : 'dark'"
        [label]="confirmLabel"
        [disabled]="confirmDisabled"
        (btnClick)="onConfirm()">
      </kt-button-v1>
    </ng-container>
  </div>

</div>
